import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Subfee.Delete.IRequest;
type Response = Api.Core.Subfee.Delete.IResponse;
type Headers = Api.Core.Subfee.Delete.IHeaders;
const url = '/api/ProductManagement/Subfee/:id';
export default async function productDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
